export default __webpack_public_path__ + "static/ai-marketing-5--mobile-31a6e7b87560291432b82dbb8fb95ff8.png";